export enum BasementFinishType {
  FINISHED = 'Finished',
  UNFINISHED = 'Unfinished',
  PARTIALLY_FINISHED = 'Partially Finished',
}
